<!-- Modal para completar datos de usuario -->
<h1 mat-dialog-title>Completa tus datos</h1>

<div mat-dialog-content>
    <p>Para acceder al chat de IA, necesitamos que completes los siguientes datos personales:</p>

    <form [formGroup]="userDataForm" style="width: 100%; padding: 1rem 0rem;">
        <!--? selector  tipo doc identidad -->
        <div class="flex-auto relative mb-[1rem]">
            <div class="relative">
                <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                    <svg [attr.fill]="focusedInput === 'tipoDocIdent' ? '#1c8549' : '#969897'" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2M8.715 8c1.151 0 2 .849 2 2s-.849 2-2 2s-2-.849-2-2s.848-2 2-2m3.715 8H5v-.465c0-1.373 1.676-2.785 3.715-2.785s3.715 1.412 3.715 2.785zM19 15h-4v-2h4zm0-4h-5V9h5z"/>
                    </svg>
                </div>
                <select
                    class="block w-full text-[14px] md:text-[15px] text-black outline-0 bg-[#f5f5f5] h-[45px] md:h-[48px] rounded-[100px] border focus:border-verde1 placeholder:text-[#4c4c4c] placeholder:text-[15px] placeholder:transition-all focus:placeholder:text-transparent pl-10"
                    formControlName="tipoDocIdent"
                    (focus)="onFocus('tipoDocIdent')"
                    (blur)="onBlur()"
                    required
                >
                    <option value="" disabled selected hidden>Tipo de Documento</option>
                    <option *ngFor="let type of tiposDocumentos" [value]="type">{{ type }}</option>
                </select>
            </div>

            <div class="text-red-500 text-[13px] min-h-[20px] "
                [ngClass]="{'invisible': !userDataForm.controls['tipoDocIdent'].invalid || !userDataForm.controls['tipoDocIdent'].touched}">
                <mat-error *ngIf="userDataForm.get('tipoDocIdent')?.errors?.['required']">
                    El campo Tipo de Documento es obligatorio.
                </mat-error>
            </div>
        </div>
        <!--? Input de num doc indentida -->
        <div class="flex-auto relative mb-[1rem]">
            <div class="relative">
                <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                    <svg [attr.fill]="focusedInput === 'numDocIdent' ? '#1c8549' : '#969897'" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 17V9H2V7h4v10zm18-2a2 2 0 0 1-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4a2 2 0 0 1 2 2v1.5a1.5 1.5 0 0 1-1.5 1.5a1.5 1.5 0 0 1 1.5 1.5zm-8 0v2H8v-4a2 2 0 0 1 2-2h2V9H8V7h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v2z"/>
                    </svg>
                </div>
                <input
                    type="text"
                    class="block w-full text-[14px] md:text-[15px] text-black outline-0 bg-[#f5f5f5] h-[45px] md:h-[48px] rounded-[100px] border focus:border-verde1 placeholder:text-[#4c4c4c] placeholder:text-[15px] placeholder:transition-all focus:placeholder:text-transparent pl-10"
                    placeholder="Número de Documento"
                    formControlName="numDocIdent"
                    (focus)="onFocus('numDocIdent')"
                    (blur)="onBlur(); userDataForm.controls['numDocIdent'].markAsTouched()"
                    [tipoDocIdent]="userDataForm.get('tipoDocIdent')?.value"
                    appDocumentNumber
                    required
                >
            </div>

            <div *ngIf="userDataForm.controls['numDocIdent'].invalid && userDataForm.controls['numDocIdent'].touched"
                class="text-red-500 text-[13px] min-h-[20px]">
                <mat-error *ngIf="userDataForm.controls['numDocIdent'].errors?.['required']">
                    El campo Número de Documento es obligatorio.
                </mat-error>
                <mat-error *ngIf=" userDataForm.controls['tipoDocIdent']?.value === 'Cédula de Ciudadanía'">
                    La cédula de ciudadanía debe tener entre 7 y 10 dígitos.
                </mat-error>
                <mat-error *ngIf=" userDataForm.controls['tipoDocIdent']?.value === 'Pasaporte'">
                    El pasaporte debe tener entre 5 y 20 caracteres alfanuméricos.
                </mat-error>
                <mat-error *ngIf=" userDataForm.controls['tipoDocIdent']?.value === 'Tarjeta de Identidad'">
                    La tarjeta de identidad debe tener entre 7 y 12 dígitos.
                </mat-error>
                <mat-error *ngIf=" userDataForm.controls['tipoDocIdent']?.value === 'Cédula de Extranjería'">
                    La cédula de Extranjería debe tener entre 7 y 15 caracteres alfanuméricos.
                </mat-error>
                <mat-error *ngIf="userDataForm.controls['numDocIdent'].errors?.['sanitize']?.hasMaliciousChars">
                El número de documento contiene caracteres no permitidos como <> ( ) ; ' ".
                </mat-error>
                <mat-error *ngIf="userDataForm.controls['numDocIdent'].errors?.['sanitize']?.hasSQLInjection">
                    El campo contiene palabras o patrones potencialmente maliciosos.
                </mat-error>
            </div>
        </div>
        <!--? Input de num telefono -->
        <div class="flex-auto relative ">
            <div class="relative">
                <!-- Ícono ajustado con posicionamiento relativo -->
                <div class="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                    <svg [attr.fill]="focusedInput === 'numTelefono' ? '#1c8549' : '#969897'" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
                        <path d="M15.75 2A2.25 2.25 0 0 1 18 4.25v15.5A2.25 2.25 0 0 1 15.75 22h-7.5A2.25 2.25 0 0 1 6 19.75V4.25A2.25 2.25 0 0 1 8.25 2zm-2.5 16h-2.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5"/>
                    </svg>
                </div>

                <!-- Input personalizado sin usar matInput -->
                <input
                    type="text"
                    class="block w-full text-[14px] md:text-[15px] text-black outline-0 bg-[#f5f5f5] h-[45px] md:h-[48px] rounded-[100px] border focus:border-verde1 placeholder:text-[#4c4c4c] placeholder:text-[15px] placeholder:transition-all focus:placeholder:text-transparent pl-10"
                    placeholder="Número de Celular"
                    formControlName="numTelefono"
                    (focus)="onFocus('numTelefono')"
                    (blur)="onBlur()"
                    minlength="10"
                    maxlength="10"
                    pattern="^[3][0-9]{9}$"
                    appTelNumberOnly
                    required
                >
            </div>

            <!-- Mat-error para mensajes de error -->
            <div class="text-red-500 text-[13px] min-h-[20px]"
                [ngClass]="{'invisible': !userDataForm.controls['numTelefono'].invalid || !userDataForm.controls['numTelefono'].touched}">
                <mat-error
                    *ngIf="userDataForm.controls['numTelefono'].errors?.['required']">
                    El campo de número de celular es obligatorio.
                </mat-error>
                <mat-error
                    *ngIf="userDataForm.controls['numTelefono'].errors?.['pattern']">
                    El número de celular debe comenzar con 3 y contener solo números (10 dígitos).
                </mat-error>
                <mat-error
                    *ngIf="userDataForm.controls['numTelefono'].errors?.['sanitize']?.hasHTMLTags">
                    El número de celular no debe contener etiquetas HTML.
                </mat-error>
                <mat-error
                    *ngIf="userDataForm.controls['numTelefono'].errors?.['sanitize']?.hasMaliciousChars">
                    El número de celular contiene caracteres no permitidos como <> ( ) ; ' ".
                </mat-error>
                <mat-error
                    *ngIf="userDataForm.controls['numTelefono'].errors?.['sanitize']?.hasSQLInjection">
                    El campo contiene palabras o patrones potencialmente maliciosos.
                </mat-error>
            </div>
        </div>
    </form>

    <p style="font-size: 0.9rem; color: gray; margin-top: 1rem;">
        * Todos los campos son obligatorios para acceder al chat de IA.
    </p>
</div>

<div mat-dialog-actions>
    <button mat-button color="primary" (click)="cancelar()">Cancelar</button>
    <button mat-button color="primary" (click)="submit()" [mat-dialog-close]="data" cdkFocusInitial [disabled]="!userDataForm.valid">Confirmar</button>
</div>
